

$(window).on("load", function () {
	var $section = $("#mwly-characters");
	if (!$section.length) {
		return;
	}

	var $characters = $section.find(".data-character[data-character]");
	var $items = $section.find(".list-items a");

	if (!$characters.length || !$items.length) {
		return;
	}

	function setActiveCharacter(targetKey) {
		var $matched = $characters.filter('[data-character="' + targetKey + '"]');
		var hasMatch = $matched.length > 0;

		$characters.removeClass("active");
		if (hasMatch) {
			$matched.addClass("active");
		} else {
			$characters.eq(0).addClass("active");
		}

		$items.removeClass("active");
		if (hasMatch) {
			$items.filter('[data-character-target="' + targetKey + '"]').addClass("active");
		}
	}

	$items.on("click", function (event) {
		event.preventDefault();
		var targetKey = $(this).data("characterTarget");
		if (!targetKey) {
			return;
		}
		setActiveCharacter(targetKey);
	});

	var initialTarget = $section.find(".list-items a[data-character-target]").first().data("characterTarget");
	setActiveCharacter(initialTarget || $characters.first().data("character"));
});
